import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["panel"];

    toggle(event) {
        console.log("Hello")
        const panel = this.hasPanelTarget ? this.panelTarget : null;
        if (!panel) return;
        console.log("Hello2")
        const isHidden = panel.classList.contains("hidden");
        panel.classList.toggle("hidden", !isHidden ? true : false);
        // ARIA
        const btn = event.currentTarget;
        btn.setAttribute("aria-expanded", isHidden ? "true" : "false");
    }
}
